import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import TestUserModel from "../../models/testuser.modal";
import { helper } from "../../lib/helper";
const Testuser = () => {
  const [modal, setModal] = useState();
  const [data, setData] = useState();

  const toggleModal = () => {
    setModal(!modal);
  };
  const deleteuser = async(id)=>{
    // Simulate delete operation
    setTimeout(() => {
      setData(prevData => ({
        ...prevData,
        data: prevData.data.filter(user => user.id !== id)
      }));
      helper.sweetalert.toast("Test user deleted successfully", "success");
    }, 500);
  }
  const AddUser = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    const mobile = form.get("mobile");
    
    // Validate mobile number
    if (!mobile || mobile.length !== 10) {
      helper.sweetalert.toast("Please enter a valid 10-digit mobile number", "warning");
      return;
    }
    
    // Check if mobile already exists
    const existingUser = data?.data?.find(user => user.mobile === mobile);
    if (existingUser) {
      helper.sweetalert.toast("Mobile number already exists", "warning");
      return;
    }
    
    // Simulate adding new test user
    const newUser = {
      id: (data?.data?.length + 1).toString(),
      mobile: mobile,
      updatedAt: new Date().toISOString()
    };
    
    setTimeout(() => {
      setData(prevData => ({
        ...prevData,
        data: [...(prevData?.data || []), newUser]
      }));
      toggleModal();
      helper.sweetalert.toast("Test user added successfully", "success");
    }, 500);
  };
  const getlist = async () => {
    // Dummy data for test users
    const dummyTestUserData = {
      data: [
        {
          id: "1",
          mobile: "9876543210",
          updatedAt: "2024-01-15T10:30:00Z"
        },
        {
          id: "2",
          mobile: "9876543211",
          updatedAt: "2024-01-16T14:20:00Z"
        },
        {
          id: "3",
          mobile: "9876543212",
          updatedAt: "2024-01-17T09:15:00Z"
        },
        {
          id: "4",
          mobile: "9876543213",
          updatedAt: "2024-01-18T16:45:00Z"
        },
        {
          id: "5",
          mobile: "9876543214",
          updatedAt: "2024-01-19T11:30:00Z"
        },
        {
          id: "6",
          mobile: "9876543215",
          updatedAt: "2024-01-20T13:25:00Z"
        }
      ]
    };
    
    setTimeout(() => {
      setData(dummyTestUserData);
    }, 1000);
  };
  useEffect(() => {
    getlist();
  }, []);
  return (
    <>
      <Container className="px-4 py-7">
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">Test user</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  {/*<Input
                  className="mr-4"
                  type="text"
                  placeholder="Search"
                  size="sm"
                />*/}
                  <Button
                    size="sm"
                    onClick={toggleModal}
                    style={{ backgroundColor: "#080278", color: "white" }}
                  >
                    +Add
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light ">
                  <tr>
                    <th scope="col">S.NO</th>
                    <th scope="col">Mobile</th>
                    <th scope="col">Added on</th>

                    {/* <th scope="col">Password</th> */}

                    <th>Action</th>
                    <th scope="col" />
                  </tr>
                </thead>

                <tbody>
                  {data?.data?.map((item, index) => {
                    const date = new Date(item?.updatedAt);

                    const day = String(date.getDate()).padStart(2, "0");
                    const month = String(date.getMonth() + 1).padStart(2, "0"); 
                    const year = date.getFullYear();

                  
                    let hours = date.getUTCHours();
                    let period = hours < 12 ? "am" : "pm";

                    
                    if (hours === 0) {
                      hours = 12; 
                    } else if (hours > 12) {
                      hours -= 12; 
                    }

                  
                    const minutes = String(date.getUTCMinutes()).padStart(
                      2,
                      "0"
                    );

                  
                    const formattedTime = `${hours}:${minutes} ${" "}${period}`;
                    const formattedDate = `${day}-${month}-${year} ${formattedTime}`;
                    return (
                      <tr style={{ cursor: "pointer" }}>
                        <td key={index}>{index + 1}</td>
                        <td>{item?.mobile}</td>
                        <td>{formattedDate}</td>

                        <td
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            // justifyContent: "center",
                            // alignItems: "center",
                          }}
                        >
                          <UncontrolledTooltip
                            placement="top"
                            target="userTooltip"
                          >
                            Delete
                          </UncontrolledTooltip>
                          <p
                            style={{
                              margin: "0 8px",
                              fontSize: "15px",
                              color: "red",
                              marginTop: "10px",
                              // backgroundColor: "#f5f5f5",
                              display: "inline-block",
                              // padding: "5px", // Optional: Add padding for better appearance
                              borderRadius: "20%", // Optional: Make it a circle
                            }}
                            id="userTooltip"
                            onClick={()=>{deleteuser(item?.id)}}
                          >
                            <i className="fas fa-trash"></i>
                          </p>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>

        <Modal isOpen={modal} toggle={toggleModal} size="lg">
          <ModalHeader toggle={toggleModal}>
            <h4> Add Test user</h4>
          </ModalHeader>

          <ModalBody>
            <Form onSubmit={AddUser}>
              <Row>
                <Col md={12}>
                  <Label> Mobile Number </Label>
                  <Input
                    name="mobile"
                    type="text"
                    placeholder="Enter Mobile number"
                  />
                </Col>
              </Row>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
                {/* 
                      {addsLoadig ? (
                        <Loader color={"blue"} />
                      ) : ( */}
                <Button
                  color="primary"
                  type="submit"
                  style={{
                    float: "right",
                    marginLeft: "5%",
                    backgroundColor: "#080278",
                    color: "white",
                  }}
                  // onClick={}
                >
                  Save
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </Container>
    </>
  );
};

export default Testuser;
